"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventChannel = void 0;
// 事件通道
class EventChannel {
    constructor() {
        // 单例实例
        // private static instance: EventChannel;
        // 广播通道或替代方案
        this.channel = null;
        this.useLocalStorageFallback = false;
        // 回调队列
        this.callBackQueue = [];
        // 本地存储事件名称
        this.LOCAL_STORAGE_EVENT = 'BOSSVN_EVENT_CHANNEL';
        // 回调ID计数器
        this.callbackIdCounter = 0;
        this.initializeChannel();
    }
    // 初始化通信通道
    initializeChannel() {
        // 检测是否支持 BroadcastChannel
        if (typeof BroadcastChannel !== 'undefined') {
            try {
                this.channel = new BroadcastChannel('BOSSVN');
                this.channel.onmessage = (event) => {
                    this.handleMessage(event.data);
                };
                return;
            }
            catch (e) {
                console.warn('BroadcastChannel initialization failed, falling back to localStorage', e);
            }
        }
        // 使用 localStorage 回退方案
        this.useLocalStorageFallback = true;
        window.addEventListener('storage', (event) => {
            if (event.key === this.LOCAL_STORAGE_EVENT && event.newValue) {
                this.handleMessage(JSON.parse(event.newValue));
            }
        });
    }
    // 处理接收到的消息
    handleMessage(data) {
        try {
            const action = data;
            this.executeCallBackQueue(action);
        }
        catch (e) {
            console.error('Error processing message:', e);
        }
    }
    // 执行回调队列
    executeCallBackQueue(action) {
        const { channelType } = action;
        // 创建副本遍历，防止回调中修改队列导致问题
        const queueCopy = [...this.callBackQueue];
        queueCopy.forEach((item) => {
            const { channelType: _channelType, channelCallBack } = item !== null && item !== void 0 ? item : {};
            if (channelType === _channelType) {
                try {
                    channelCallBack === null || channelCallBack === void 0 ? void 0 : channelCallBack(action);
                }
                catch (e) {
                    console.error('Error in callback execution:', e);
                }
            }
        });
    }
    // 获取单例
    static getInstance() {
        if (typeof window !== 'undefined') {
            // 优先使用 Symbol Registry 方案
            const symbolKey = Symbol.for('@bossvn/core:EventChannel');
            if (!window[symbolKey]) {
                window[symbolKey] = new EventChannel();
            }
            // 保持向后兼容性
            if (!window.globalChannelEventChannelInstance) {
                window.globalChannelEventChannelInstance = window[symbolKey];
            }
            return window[symbolKey];
        }
        return undefined;
    }
    /**
     * 发送消息到指定频道，并可选择立即执行回调
     * @param channelAction 包含频道类型和动作的参数对象
     * @param isImmediate 是否立即执行回调 默认'Delay'
     */
    toPostMessage(channelAction, isImmediate = 'Delay') {
        // 是否先执行一次
        if (['Immediate', 'Once'].includes(isImmediate)) {
            this.executeCallBackQueue(channelAction);
            // 是否只执行一次
            if (isImmediate === 'Once')
                return;
        }
        // 发送消息
        if (this.useLocalStorageFallback) {
            // 使用 localStorage 回退方案
            localStorage.setItem(this.LOCAL_STORAGE_EVENT, JSON.stringify(channelAction));
            // 立即移除以避免重复处理
            setTimeout(() => localStorage.removeItem(this.LOCAL_STORAGE_EVENT), 0);
        }
        else if (this.channel) {
            // 使用 BroadcastChannel
            this.channel.postMessage(channelAction);
        }
    }
    /**
     * 将消息获取请求添加到回调队列中
     * @param channelType 消息通道类型
     * @param channelCallBack 消息回调函数
     * @param callbackId 可选回调ID，便于精确移除
     * @returns 返回回调ID，可用于后续移除
     */
    toGetMessage(channelType, channelCallBack, callbackId) {
        const id = callbackId || `callback_${++this.callbackIdCounter}`;
        this.callBackQueue.push({
            channelType,
            channelCallBack,
            callbackId: id,
        });
        return id;
    }
    /**
     * 移除消息监听器
     * @param identifier 可以是通道类型、回调函数或回调ID
     * @param channelCallBack 可选，要移除的特定回调函数
     */
    removeMessageListener(identifier, channelCallBack) {
        if (typeof identifier === 'function') {
            // 通过回调函数移除
            this.callBackQueue = this.callBackQueue.filter((item) => item.channelCallBack !== identifier);
        }
        else if (typeof identifier === 'string') {
            if (channelCallBack) {
                // 通过通道类型+回调函数移除
                this.callBackQueue = this.callBackQueue.filter((item) => !(item.channelType === identifier && item.channelCallBack === channelCallBack));
            }
            else if (identifier.startsWith('callback_')) {
                // 通过回调ID移除
                this.callBackQueue = this.callBackQueue.filter((item) => item.callbackId !== identifier);
            }
            else {
                // 通过通道类型移除所有该类型的回调
                this.callBackQueue = this.callBackQueue.filter((item) => item.channelType !== identifier);
            }
        }
    }
    /**
     * 清除所有消息监听器
     */
    clearAllListeners() {
        this.callBackQueue = [];
    }
}
exports.EventChannel = EventChannel;
